export default __webpack_public_path__ + "static/media/fauna-challenges.6986665f.png";